import React from 'react';
import { Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import box from '../../assets/empty_box.png'
import {useTranslation} from "react-i18next";

const DataNotFound = ({message} ) => {

    const { t } = useTranslation();
    const notFoundMessage = message || t("dataNotFound")

    const useStyles = makeStyles((theme) => {
        return {
            notFound:{
                display:"flex",
                height:"100%",
                width:"100%",
                flexDirection:"column",
                justifyContent:"center",
                alignContent:"center",
                alignItems:"center",
            },
            text:{
                color:"#dddddd"
            },
            img:{
                width :180,
                paddingBottom : 10,
                opacity: 0.9
            },

        }
    });
    const classes = useStyles();
    return (
        <div className={classes.notFound}>
            <img className={classes.img} src={box} alt="logo"/>
            <Typography
                data-testid={"not-found-message"}
                variant={"h5"} align={"center"} className={classes.text} >
                {notFoundMessage}
            </Typography>
        </div>
    );
};

export default DataNotFound;
